import React from 'react';
import {Col, FormControl, Row} from 'react-bootstrap';
import {Control} from 'react-redux-form';
// import RequiredInput from '../../../../common/form/elements/required-input';

const PointsManagementLevel = props => (
  <div>
    <Row className="form-group">
      <Col md={12}>
        <b>{props.name}</b>
      </Col>
    </Row>
    <Row className="form-group">
      <Col md={3}>
        <h4>Points to next level</h4>
      </Col>
      <Col md={9}>
        <Control.text
          model={`.levels.${props.id}.points_threshold`}
          component={FormControl}
          placeholder='Enter the number of points to include in the level threshold calculation'
          disabled={!props.nextLevel || props.isEdit}
        />
      </Col>
    </Row>
  </div>
);

export default PointsManagementLevel;



// WEBPACK FOOTER //
// ./src/components/admin/objectives/display_it/add-display-its/points_management_level.jsx